(() => {
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const labels = {
    close: isEnglish ? 'Close' : 'Schließen',
    filter: isEnglish ? 'Open filters and sorting' : 'Filter und Sortierung öffnen',
    submenu: isEnglish ? 'Open submenu' : 'Untermenü öffnen',
    sort: isEnglish ? 'Sort by' : 'Sortieren nach',
    minPrice: isEnglish ? 'Minimum price' : 'Mindestpreis',
    maxPrice: isEnglish ? 'Maximum price' : 'Höchstpreis'
  };

  const activateOnKeyboard = (element) => {
    element.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        element.click();
      }
    });
  };

  const enhance = (root = document) => {
    root.querySelectorAll?.('side-panel-close:not([data-a11y-ready])').forEach((element) => {
      element.dataset.a11yReady = 'true';
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      if (!element.hasAttribute('aria-label')) element.setAttribute('aria-label', labels.close);
      activateOnKeyboard(element);
    });

    root.querySelectorAll?.('facet-toggle:not([data-a11y-ready])').forEach((element) => {
      element.dataset.a11yReady = 'true';
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.setAttribute('aria-controls', 'Facet-Drawer');
      element.setAttribute('aria-expanded', document.getElementById('Facet-Drawer')?.classList.contains('active') ? 'true' : 'false');
      if (!element.hasAttribute('aria-label')) element.setAttribute('aria-label', labels.filter);
      activateOnKeyboard(element);
    });

    root.querySelectorAll?.('custom-select .custom-select--button:not([data-a11y-ready])').forEach((button) => {
      button.dataset.a11yReady = 'true';
      button.setAttribute('aria-haspopup', 'listbox');
      if (!button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'false');
      const selected = button.querySelector('.custom-select--text')?.textContent?.trim();
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', selected ? `${labels.sort}: ${selected}` : labels.sort);
    });

    root.querySelectorAll?.('.thb-arrow:not([data-a11y-ready])').forEach((arrow, index) => {
      arrow.dataset.a11yReady = 'true';
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('tabindex', '0');
      const submenu = arrow.parentElement?.querySelector(':scope > .sub-menu');
      if (submenu) {
        if (!submenu.id) submenu.id = `footer-submenu-${Date.now()}-${index}`;
        arrow.setAttribute('aria-controls', submenu.id);
        arrow.setAttribute('aria-expanded', submenu.classList.contains('active') ? 'true' : 'false');
      }
      const linkText = arrow.parentElement?.querySelector(':scope > a')?.textContent?.trim();
      if (!arrow.hasAttribute('aria-label')) arrow.setAttribute('aria-label', linkText ? `${labels.submenu}: ${linkText}` : labels.submenu);
      activateOnKeyboard(arrow);
      arrow.addEventListener('click', () => setTimeout(() => {
        if (submenu) arrow.setAttribute('aria-expanded', submenu.classList.contains('active') ? 'true' : 'false');
      }, 0));
    });

    root.querySelectorAll?.('.thb-widget-title.collapsible:not([data-a11y-ready])').forEach((button) => {
      button.dataset.a11yReady = 'true';
      button.setAttribute('aria-expanded', button.classList.contains('active') ? 'true' : 'false');
      button.addEventListener('click', () => setTimeout(() => {
        button.setAttribute('aria-expanded', button.classList.contains('active') ? 'true' : 'false');
      }, 0));
    });

    root.querySelectorAll?.('.noUi-handle-lower:not([data-a11y-ready])').forEach((handle) => {
      handle.dataset.a11yReady = 'true';
      handle.setAttribute('aria-label', labels.minPrice);
    });
    root.querySelectorAll?.('.noUi-handle-upper:not([data-a11y-ready])').forEach((handle) => {
      handle.dataset.a11yReady = 'true';
      handle.setAttribute('aria-label', labels.maxPrice);
    });

    root.querySelectorAll?.('.field.select label[for]').forEach((label) => {
      const select = label.closest('.field.select')?.querySelector('select');
      if (select && !select.id && label.htmlFor) select.id = label.htmlFor;
    });

    root.querySelectorAll?.('.form-notification.success:not([data-a11y-ready])').forEach((message) => {
      message.dataset.a11yReady = 'true';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
    });
    root.querySelectorAll?.('.form-notification.error:not([data-a11y-ready])').forEach((message) => {
      message.dataset.a11yReady = 'true';
      message.setAttribute('role', 'alert');
      message.setAttribute('aria-live', 'assertive');
    });
  };

  document.addEventListener('panel:open', (event) => {
    if (event.detail?.panel?.id === 'Facet-Drawer') document.querySelectorAll('facet-toggle').forEach((el) => el.setAttribute('aria-expanded', 'true'));
  });
  document.addEventListener('panel:closed', (event) => {
    if (event.detail?.panel?.id === 'Facet-Drawer') document.querySelectorAll('facet-toggle').forEach((el) => el.setAttribute('aria-expanded', 'false'));
  });

  const start = () => {
    enhance(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) enhance(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
